module.exports = __webpack_public_path__ + "img/simulado-default.c9b024a0.png";